<template>
    <button class="btn shadow-xs"
            :style="customStyle"
            @click="$emit('click')"
            @mouseover="hoverActive = true"
            @mouseout="hoverActive = false"
    >
        <i v-if="icon" :class="icon" style="color: inherit;"/>
        {{ __('actions.sign_in_with_provider', {provider: providerName}) }}
    </button>
</template>

<script>
export default {
    props: {
        icon: String,
        providerName: String,
        bgColor: {
            type: String,
            default: '#ffffff'
        },
        borderColor: {
            type: String,
            default: '#f6f6f6'
        },
        fgColor: {
            type: String,
            default: '#111111'
        },
    },

    data() {
        return {
            hoverActive: false,
        }
    },

    computed: {
        customStyle() {
            return this.hoverActive
                ? `color:${this.fgColor};background:${this.borderColor};border-color:${this.borderColor};`
                : `color:${this.fgColor};background:${this.bgColor};border-color:${this.borderColor};`
        }
    }
}
</script>
